module.exports = __webpack_public_path__ + "img/logo-negro.dbf99508.svg";